import React, { Fragment } from 'react'
import { useField } from 'react-final-form'
import NumberFormatCustom from './NumberFormatCustom'
import { FormHelperText, TextField } from '@material-ui/core'

const NumberFormatInput = props => {
  const { meta, input } = useField(props.name)

  return (
    <Fragment>
      <NumberFormatCustom
        {...input}
        {...meta}
        {...props}
        customInput={TextField}
      />

      {meta.error && <FormHelperText error>{meta.error}</FormHelperText>}
    </Fragment>
  )
}

export default NumberFormatInput
